var map = {
	"./block-1.svg": "fc32",
	"./block-2.svg": "d53d",
	"./block-3.svg": "b92b",
	"./block-4.svg": "3414",
	"./block-5.svg": "db37",
	"./block-6.svg": "e2f3",
	"./block-7.svg": "417b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "57ca";